'use strict';

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var batch = require('it-batch');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var batch__default = /*#__PURE__*/_interopDefaultLegacy(batch);

function trickleStream(_x, _x2, _x3) {
  return _trickleStream.apply(this, arguments);
}

function _trickleStream() {
  _trickleStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source, reduce, options) {
    var root, iteration, maxDepth, subTree, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, layer;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            root = new Root(options.layerRepeat);
            iteration = 0;
            maxDepth = 1;
            subTree = root;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 6;
            _iterator = _asyncIterator(batch__default['default'](source, options.maxChildrenPerNode));

          case 8:
            _context2.next = 10;
            return _iterator.next();

          case 10:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 26;
              break;
            }

            layer = _step.value;

            if (!subTree.isFull()) {
              _context2.next = 22;
              break;
            }

            if (!(subTree !== root)) {
              _context2.next = 19;
              break;
            }

            _context2.t0 = root;
            _context2.next = 17;
            return subTree.reduce(reduce);

          case 17:
            _context2.t1 = _context2.sent;

            _context2.t0.addChild.call(_context2.t0, _context2.t1);

          case 19:
            if (iteration && iteration % options.layerRepeat === 0) {
              maxDepth++;
            }

            subTree = new SubTree(maxDepth, options.layerRepeat, iteration);
            iteration++;

          case 22:
            subTree.append(layer);

          case 23:
            _iteratorAbruptCompletion = false;
            _context2.next = 8;
            break;

          case 26:
            _context2.next = 32;
            break;

          case 28:
            _context2.prev = 28;
            _context2.t2 = _context2["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context2.t2;

          case 32:
            _context2.prev = 32;
            _context2.prev = 33;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 37;
              break;
            }

            _context2.next = 37;
            return _iterator.return();

          case 37:
            _context2.prev = 37;

            if (!_didIteratorError) {
              _context2.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context2.finish(37);

          case 41:
            return _context2.finish(32);

          case 42:
            if (!(subTree && subTree !== root)) {
              _context2.next = 48;
              break;
            }

            _context2.t3 = root;
            _context2.next = 46;
            return subTree.reduce(reduce);

          case 46:
            _context2.t4 = _context2.sent;

            _context2.t3.addChild.call(_context2.t3, _context2.t4);

          case 48:
            return _context2.abrupt("return", root.reduce(reduce));

          case 49:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[6, 28, 32, 42], [33,, 37, 41]]);
  }));
  return _trickleStream.apply(this, arguments);
}

var SubTree = /*#__PURE__*/function () {
  function SubTree(maxDepth, layerRepeat) {
    var iteration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, SubTree);

    this.maxDepth = maxDepth;
    this.layerRepeat = layerRepeat;
    this.currentDepth = 1;
    this.iteration = iteration;
    this.root = this.node = this.parent = {
      children: [],
      depth: this.currentDepth,
      maxDepth: maxDepth,
      maxChildren: (this.maxDepth - this.currentDepth) * this.layerRepeat
    };
  }

  _createClass(SubTree, [{
    key: "isFull",
    value: function isFull() {
      if (!this.root.data) {
        return false;
      }

      if (this.currentDepth < this.maxDepth && this.node.maxChildren) {
        this._addNextNodeToParent(this.node);

        return false;
      }

      var distantRelative = this._findParent(this.node, this.currentDepth);

      if (distantRelative) {
        this._addNextNodeToParent(distantRelative);

        return false;
      }

      return true;
    }
  }, {
    key: "_addNextNodeToParent",
    value: function _addNextNodeToParent(parent) {
      this.parent = parent;
      var nextNode = {
        children: [],
        depth: parent.depth + 1,
        parent: parent,
        maxDepth: this.maxDepth,
        maxChildren: Math.floor(parent.children.length / this.layerRepeat) * this.layerRepeat
      };
      parent.children.push(nextNode);
      this.currentDepth = nextNode.depth;
      this.node = nextNode;
    }
  }, {
    key: "append",
    value: function append(layer) {
      this.node.data = layer;
    }
  }, {
    key: "reduce",
    value: function reduce(_reduce) {
      return this._reduce(this.root, _reduce);
    }
  }, {
    key: "_reduce",
    value: function () {
      var _reduce2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, reduce) {
        var _this = this;

        var children;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                children = [];

                if (!node.children.length) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return Promise.all(node.children.filter(function (child) {
                  return child.data;
                }).map(function (child) {
                  return _this._reduce(child, reduce);
                }));

              case 4:
                children = _context.sent;

              case 5:
                return _context.abrupt("return", reduce((node.data || []).concat(children)));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function _reduce(_x4, _x5) {
        return _reduce2.apply(this, arguments);
      }

      return _reduce;
    }()
  }, {
    key: "_findParent",
    value: function _findParent(node, depth) {
      var parent = node.parent;

      if (!parent || parent.depth === 0) {
        return;
      }

      if (parent.children.length === parent.maxChildren || !parent.maxChildren) {
        return this._findParent(parent, depth);
      }

      return parent;
    }
  }]);

  return SubTree;
}();

var Root = /*#__PURE__*/function (_SubTree) {
  _inherits(Root, _SubTree);

  var _super = _createSuper(Root);

  function Root(layerRepeat) {
    var _this2;

    _classCallCheck(this, Root);

    _this2 = _super.call(this, 0, layerRepeat);
    _this2.root.depth = 0;
    _this2.currentDepth = 1;
    return _this2;
  }

  _createClass(Root, [{
    key: "addChild",
    value: function addChild(child) {
      this.root.children.push(child);
    }
  }, {
    key: "reduce",
    value: function reduce(_reduce3) {
      return _reduce3((this.root.data || []).concat(this.root.children));
    }
  }]);

  return Root;
}(SubTree);

module.exports = trickleStream;